// import PropTypes from "prop-types"
import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import investors from './getInvestors';

import './who.our.investors.less';

const getName = (fileName) => {
  const splited = fileName.split('-');
  const position = splited[1] || 'N/A';
  return position.split('.').slice(0, -1).join('.').replace('_', ' ');
};

const ImageComponent = ({ investor }) => {
  const { t } = useTranslation();
  const name = getName(investor.node.relativePath);
  return (
    <div className="m-whoOurInvestors__teamIndividual">
      <GatsbyImage
        image={getImage(investor.node)}
        className="a-whoOurInvestors__avatar"
        objectFit="contain"
        objectPosition="50% 50%"
        title={t('images.investors.title')}
        alt={t('images.investors.alt', { investor: name })}
      />
    </div>
  );
};

const Steps = () => {
  const { t } = useTranslation();
  const investorsList = investors();
  return (
    <div className="o-whoOurInvestorsLandingPage">
      <div className="m-globalContentContainer">
        <div className="-page-title a-landingPage__title ">
          {t('web.about.investors.title')}
        </div>
        <div className="m-whoOurInvestors__teamContainer">
          {investorsList.map((investor, index) => (
            <ImageComponent investor={investor} key={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Steps;
